import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
let ErrorLog = class ErrorLog extends VuexModule {
  constructor() {
    super(...arguments);
    this.logs = [];
  }
  ADD_ERROR_LOG(log) {
    this.logs.push(log);
  }
  CLEAR_ERROR_LOG() {
    this.logs.splice(0);
  }
  AddErrorLog(log) {
    this.ADD_ERROR_LOG(log);
  }
  ClearErrorLog() {
    this.CLEAR_ERROR_LOG();
  }
};
__decorate([Mutation], ErrorLog.prototype, "ADD_ERROR_LOG", null);
__decorate([Mutation], ErrorLog.prototype, "CLEAR_ERROR_LOG", null);
__decorate([Action], ErrorLog.prototype, "AddErrorLog", null);
__decorate([Action], ErrorLog.prototype, "ClearErrorLog", null);
ErrorLog = __decorate([Module({
  dynamic: true,
  store,
  name: 'errorLog'
})], ErrorLog);
export const ErrorLogModule = getModule(ErrorLog);